import React from "react";
import ModalComponent from "../../../atoms/Modal";
import DynamicForm from "Components/DynamicForm/dynamicForm";
import { navigate } from "atoms/BreadCrumb";
import FormBuilder from "../../../Components/DynamicForm/formBuilder";
import { Card, CardBody, CardHeader } from "reactstrap";

interface ModalCreateProps {
  show: boolean
  setOpenModal: (arg: boolean) => void
  currentCatalog: navigate
  onSubmit: Function
  setChildForm: Function
  childForm: any
  isUpdate: boolean
  callback: Function[]
}

const submitProps = (isUpdate: boolean) => {
  return isUpdate ? { class: '', text: "Actualizar Catálogo" } : { class: '', text: "Crear Catálogo" }
}

const ModalCreate: React.FC<ModalCreateProps> = ({
                                                   show,
                                                   setOpenModal,
                                                   currentCatalog,
                                                   onSubmit,
                                                   setChildForm,
                                                   childForm,
                                                   isUpdate,
                                                   callback
                                                 }: ModalCreateProps) => {
  return (
    <ModalComponent show={show} setOpen={setOpenModal} title={`${isUpdate ? 'Actualizar': 'Crear'} Catálogo`} size="lg">
      <DynamicForm key={currentCatalog.id + (isUpdate ? "-update" : "-create")} structure={currentCatalog.structure} onSubmit={onSubmit} submitProps={submitProps(isUpdate)} callback={callback}>
        <Card
          className="my-2"
        >
          <CardHeader tag="h5">
            Formulario para Subcatálogos
          </CardHeader>
          <CardBody>
            <FormBuilder setChildForm={setChildForm} childForm={childForm}/>
          </CardBody>
        </Card>
      </DynamicForm>
    </ModalComponent>
  )

}

export default ModalCreate


